module.exports = __webpack_public_path__ + "image/jicai_docs_3.e8c8d69.png";